import React from 'react';
import companyDetails from './CompanyDetails';
import companyAddress from './AddCompanyAddress';
import getGST from '../../../containers/Income/SENP/getGst';
import AddressProof from './BusinessAddressProof';
import Documents from './SENPDocuments';
import * as Yup from 'yup';
import Directors from './DirectorPage/Directors';
import PersonalDetails from '../PersonalDetails/PersonalDetails';
import OtherSavings from '../../Income/IncomeDetailsComponent/OtherSaving/OtherSaving';
import AddSalary from '../../Income/IncomeDetailsComponent/SalaryDetails/AddSalary';
import AddLoan from '../LoanDetails/AddLoan';
import { getApplicantionInfo } from '../../../common/utils/applicantionInfo';
import { saveOthersSaving } from '../../../common/constants/api';
import SuccessPopUP from '../../../containers/UserKyc/UserPopUP/IncomeSuccessPopUp';
import Partner from './partner/partner';
import * as _ from 'lodash';
import ITR from './IncomeFiles/ITR';

let allValues = { step: 'SENP' };
export const getAllValues = () => allValues;
let viewAccount = false;

export const isViewAccount = () => {
  return viewAccount;
};

const SENPSteps = [
  {
    id: 'companyDetails',
    component: companyDetails,
    initialValues: {
      companyType: '',
      company_name: '',
      sub_industry: { value: '', label: 'Choose Sub Industry' },
      industry_list: { value: '', label: 'Choose Industry"' },
      nature_of_business: { value: '', label: 'Nature Of Business' },
      cin: '',
      llpin: ''
    },
    validationSchema: Yup.object().shape({
      companyType: Yup.string().required('Required'),
      industry_list: Yup.object().shape({
        value: Yup.string().required('Required')
      }),
      cin: Yup.string()
        .when('companyType', {
          is: 'Limited',
          then: Yup.string()
            .required('Required')
            .min(21, 'Must be 21 digits')
            .max(21, 'Must be 21 digits')
            .matches(
              /^([L|U]{1})([0-9]{5})([A-Za-z]{2})([0-9]{4})([A-Za-z]{3})([0-9]{6})$/,
              'Not a Valid CIN'
            ),
          otherwise: Yup.string().when('companyType', {
            is: 'Private Limited',
            then: Yup.string()
              .required('Required')
              .min(21, 'Must be 21 digits')
              .max(21, 'Must be 21 digits')
              .matches(
                /^([L|U]{1})([0-9]{5})([A-Za-z]{2})([0-9]{4})([A-Za-z]{3})([0-9]{6})$/,
                'Not a Valid CIN'
              )
          })
        })
        .nullable(),
      nature_of_business: Yup.object().shape({
        value: Yup.string().required('Required')
      }),
      llpin: Yup.string()
        .when('companyType', {
          is: 'LLP',
          then: Yup.string().required('required')
        })
        .nullable(),
      company_pan: Yup.string()
        .when('companyType', {
          is: val =>
            val == 'LLP' || val == 'Private Limited' || val == 'Limited',
          then: Yup.string().required('required')
        })
        .nullable(),
      company_name: Yup.string().when('companyType', {
        is: 'Proprietorship',
        then: Yup.string().required('required'),
        otherwise: Yup.string().nullable()
      })
    }),
    onAction: async (sectionValues, formValues) => {
      allValues['companyDetails'] = sectionValues;
    }
  },
  {
    id: 'getGST',
    component: getGST,
    initialValues: {
      preValues: getAllValues,
      gst_number: 'yes',
      gst_value: '',
      file: [],
      imgUrl: []
    },
    validationSchema: Yup.object().shape({
      gst_value: Yup.string()
        .when('gst_number', {
          is: 'yes',
          then: Yup.string()
            .required('required')
            .matches(
              /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
              'Invalid GST No.'
            )
        })
        .nullable()
    }),
    onAction: async (sectionValues, formValues) => {}
  },
  {
    id: 'companyAddress',
    component: companyAddress,
    initialValues: {
      address: '',
      source: '',
      preAddress: false,
      currentAddress: 'no'
    },
    validationSchema: Yup.object().shape({
      currentAddress: Yup.string().when('preAddress', {
        is: true,
        then: Yup.string().required('required')
      })
    }),

    onAction: async (sectionValues, formValues) => {
      allValues['companyAddress'] = sectionValues;
    }
  },

  {
    id: 'addProof',
    component: AddressProof,
    initialValues: {
      add_proof: { value: '', label: 'Select Business Address Proof' },
      UploadRent: 0,
      file: [],
      imgUrl: [],
      preValues: getAllValues,
      utilityBIll: { value: '', label: 'Select Utility Bill' }
    },
    onAction: async (sectionValues, formValues) => {}
  },
  {
    id: 'docsLists',
    component: Documents,
    initialValues: {
      file: [],
      imgUrl: [],
      preValues: getAllValues,
      neededDocs: [],
      allValues: ''
    },
    validate: values => {
      let error = {};
      if (
        values?.allValues?.companyDetails?.companyType == 'Private Limited' ||
        values?.allValues?.companyDetails?.companyType == 'Limited'
      ) {
        if (
          !_.get(values, 'file.0.0', false) &&
          !values.moaFile &&
          !_.get(values, 'file.1.0', false) &&
          !values.aoaFile &&
          !_.get(values, 'file.2.0', false) &&
          !values.boardsres &&
          !_.get(values, 'file.3.0', false) &&
          !values.shareHolders &&
          !_.get(values, 'file.4.0', false) &&
          !values.regCertificate
        ) {
          error['error'] = 'true';
        }
      } else if (values.allValues?.companyDetails?.companyType == 'LLP') {
        if (
          !_.get(values, 'file.5.0', false) &&
          !values.llpin &&
          !_.get(values, 'file.4.0', false) &&
          !values.regCertificate
        ) {
          error['error'] = 'true';
        }
      } else if (
        values.allValues?.companyDetails?.companyType == 'Partnership'
      ) {
        if (!_.get(values, 'file.6.0', false) && !values.partnershipdeed) {
          error['error'] = 'true';
        }
      }
      return error;
    },
    onAction: async (sectionValues, formValues) => {}
  },
  {
    id: 'prtners',
    component: Partner,
    initialValues: {
      preValues: getAllValues
    }
  },
  {
    id: 'dirLists',
    component: Directors,
    initialValues: {
      file: [],
      imgUrl: [],
      pincode: '',
      state: { label: 'Select State', value: '' },
      preValues: getAllValues
    },
    onAction: async (sectionValues, formValues) => {}
  },
  {
    id: 'itr',
    component: ITR,
    initialValues: {
      file: [],
      imgUrl: [],
      pincode: '',
      statementType: 'individual'
    },
    validate: values => {
      const error = {};
      if (!values.preValues) {
        if (!values.file[0] && !values.file[1] && !values.file[2]) {
          error['error'] = true;
        }
        return error;
      }
    },
    onAction: async (sectionValues, formValues) => {}
  },
  {
    id: 'AddSalary',
    component: AddSalary,
    initialValues: {
      professionType: '',
      file: [],
      imgUrl: [],
      accountNo: '',
      ifscCode: '',
      statementType: '',
      viewAccount: isViewAccount,
      addNewAccount: true,
      preValues: getAllValues,
      accountType: 'current'
    },
    validationSchema: Yup.object().shape({
      accountNo: Yup.string().when('addNewAccount', {
        is: true,
        then: Yup.string()
          .required('Required')
          .min(9, 'Account Number Must be minimum 9 digits')
          .max(18, 'Account Number should not excced 18 digits')
      }),
      ifscCode: Yup.string().when('addNewAccount', {
        is: true,
        then: Yup.string()
          .required('Required')
          .matches(/^[A-Za-z]{4}0[A-Z0-9a-z]{6}$/, 'Invalid IFSC code Format')
      }),

      statementType: Yup.string().when('addNewAccount', {
        is: true,
        then: Yup.string().required('Required')
      })
    }),

    onAction: (sectionValues, formValues) => {}
  },
  {
    id: 'otherSaving',
    component: OtherSavings,
    initialValues: {
      gold: false,
      mutualFunds: false,
      pF: false,
      fD: false,
      uL: false,
      fA: false
    },
    validationSchema: Yup.object().shape({}),
    onAction: async (sectionValues, formValues) => {
      let data = getApplicantionInfo();
      const { leadId, leadApplicantId } = data;
      await saveOthersSaving(leadId, leadApplicantId, {
        isGold: sectionValues.gold,
        isMutualFund: sectionValues.mutualFunds,
        isPf: sectionValues.pF,
        isFdOrRd: sectionValues.fD,
        isUlOrIp: sectionValues.uL,
        isFixedAssests: sectionValues.fA
      })
        .then(res => {})
        .catch(err => {
          throw new Error(
            err?.response?.data?.message ||
              'something went wrong please try again. .'
          );
        });
    }
  },
  {
    id: 'AddLoan',
    component: AddLoan,
    initialValues: {
      file: [],
      imgUrl: [],
      lender: '',
      loanType: '',
      sanctionAmount: '',
      balanceAmount: '',
      totalTenure: '',
      balanceTenure: '',
      sanctionDocId: null,
      statementDocId: null,
      viewAccount: isViewAccount,
      addNewLoan: true
    },
    validationSchema: Yup.object().shape({
      lender: Yup.string().when('addNewLoan', {
        is: true,
        then: Yup.string().required('Required')
      }),
      loanType: Yup.string().when('addNewLoan', {
        is: true,
        then: Yup.string().required('Required')
      }),
      sanctionAmount: Yup.string().when('addNewLoan', {
        is: true,
        then: Yup.string().required('Required')
      }),
      balanceAmount: Yup.string().when('addNewLoan', {
        is: true,
        then: Yup.string().required('Required')
      }),
      totalTenure: Yup.string().when('addNewLoan', {
        is: true,
        then: Yup.string().required('Required')
      }),
      currentEmi: Yup.string().when('addNewLoan', {
        is: true,
        then: Yup.string().required('Required')
      }),
      balanceTenure: Yup.string().when('addNewLoan', {
        is: true,
        then: Yup.string().required('Required')
      })
    }),
    onAction: (sectionValues, formValues) => {}
  },
  {
    id: 'PersonalDetails',
    component: PersonalDetails,
    initialValues: {
      maritalStatus: {
        label: 'Marital Status',
        value: ''
      },
      religion: {
        label: 'Religion',
        value: ''
      },

      category: {
        label: 'Category',
        value: ''
      },
      residential: {
        label: 'Residential Status',
        value: ''
      },
      file: [],
      imgUrl: []
    },
    validationSchema: Yup.object().shape({
      maritalStatus: Yup.object().shape({
        value: Yup.string().required('Required')
      }),
      religion: Yup.object().shape({
        value: Yup.string().required('Required')
      }),
      category: Yup.object().shape({
        value: Yup.string().required('Required')
      }),
      residential: Yup.object().shape({
        value: Yup.string().required('Required')
      })
    })
  },
  {
    id: 'SuccessPopUP',
    component: SuccessPopUP
  }
];
export default SENPSteps;
